import _axios from '@/util/httpConfig.js'

export const getHtml = (contentCode, type = 'contentAnnounce') => {
  return _axios('GET', 
  `/common-content/${type}/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`
  )
} 


// WEBPACK FOOTER //
// ./src/api/html.js